import { AIAnnotationType, AIFilesType } from 'src/@types/ai';

type LanguageModelV1Source = {
  sourceType: 'url';
  id: string;
  url: string;
  title?: string;
};

export type ResultType = {
  generatedFiles: AIFilesType[];
  searchSources: LanguageModelV1Source[];
};

export const useGetContentByParts = () => {
  const getContentByAnnotations = (annotations?: AIAnnotationType[]) => {
    const result: ResultType = {
      generatedFiles: [],
      searchSources: [],
    };

    if (!annotations) return result;

    annotations.map((item) => {
      switch (item.type) {
        case 'image':
        case 'file':
          result.generatedFiles.push(item);
          break;
        case 'reasoning':
          break;
        case 'tool-invocation':
          break;
        case 'source':
          result.searchSources.push(item.source);
          break;
        default:
          break;
      }
    });
    return result;
  };

  return {
    getContentByAnnotations,
  };
};
